/**
 * cn — joins className strings, omitiendo falsy values. Reemplaza clsx/tailwind-merge.
 * Para casos simples (sin conflict resolution), esto sobra.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
    return classes.filter(Boolean).join(' ');
}

/**
 * Escape HTML entities — defensa en profundidad para texto user-provided
 * que se inserta vía dangerouslySetInnerHTML (preferentemente, evítalo).
 */
export function escapeHtml(s: unknown): string {
    return String(s ?? '').replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c] as string));
}

/**
 * Format ISO date string a formato local CL.
 */
export function formatDate(s: string | null | undefined): string {
    if (!s) return '—';
    try {
        const d = new Date(s.includes('T') ? s : s.replace(' ', 'T') + 'Z');
        return d.toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' });
    } catch {
        return s;
    }
}
